import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { RootLayout } from '@/layouts/RootLayout';
import { useSettings } from '@/store/useSettings';

import { HomePage } from '@/pages/home';
import { ProductsPage } from '@/pages/products';
import { ProductDetailPage } from '@/pages/product-detail';
import { CartPage } from '@/pages/cart';
import { CheckoutPage } from '@/pages/checkout';
import { SuccessPage } from '@/pages/success';

function App() {
    const { fetchSettings } = useSettings();

    useEffect(() => {
        fetchSettings();
    }, [fetchSettings]);

    return (
        <Routes>
            <Route path="/" element={<RootLayout />}>
                <Route index element={<HomePage />} />
                <Route path="products" element={<ProductsPage />} />
                <Route path="products/:slug" element={<ProductDetailPage />} />
                <Route path="categories" element={<div className="container py-20 text-center">Categories Page (Implement me)</div>} />
                <Route path="cart" element={<CartPage />} />
                <Route path="checkout" element={<CheckoutPage />} />
                <Route path="success" element={<SuccessPage />} />

                {/* Fallback */}
                <Route path="*" element={<div className="container py-20 text-center">404 - Not Found</div>} />
            </Route>
        </Routes>
    );
}

export default App;
